import React from 'react';
import styled from 'styled-components';
import { Breadcrumb } from '../components/Breadcrumb';
import { PageTitle } from '../components/PageTitle';



const PAGETITLE_JP = '個人情報保護方針';
const PAGETITLE_EN = 'Privacy Policy';


const PolicyContainer = styled.div.attrs({className: 'page-container'})`

  
padding: 0 0 160px;

  @media (max-width: 768px) {
   padding: 0 20px 95px;
  }

  p {
    font-size: 4.26vw;
    @media (min-width: 769px) {
    font-size: 16px;
    }
  }
`;

const PolicyContentSection = styled.section.attrs({className: 'policy-content-section'})`
  margin: 120px auto 0;
  max-width: var(--contents-maxwidth-pc);
  
  @media (min-width: 769px) {
    width:95%;
  }
`;

const PolicySignature = styled.div.attrs({className: 'policy-signature'})`
  text-align: right;
`;

const PolicyParagraphHeading = styled.h2.attrs({className: 'policy-paragraph-heading'})`
  font-size: 7.46vw;
  font-weight: normal;
  margin-top: 15%;

  @media (min-width: 769px) {
    font-size: 36px;
    margin-top: 80px;
  }
`;

const PolicyParagraphSubHeading = styled.h3.attrs({className: 'policy-paragraph-sub-heading'})`
  font-size: 6.4vw;
  font-weight: normal;
  margin-top: 8%;
  @media (min-width: 769px) {
    font-size: 24px;
    margin-top: 40px;
  }
    
`;



const PolicyParagraphSubsubHeading = styled.h4.attrs({className: 'policy-paragraph-sub-subheading'})`
  font-size: 4.26vw;
  margin-top:0;
  margin-bottom: 0.5em;
  @media (min-width: 769px) {
    font-size: 16px;
  }
    & + * {
      margin-top:0;
    }
    
`;


const PolicyTableWrapper = styled.div.attrs({className: 'policy-table-wapper'})`
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
`;




const PolicyTable = styled.table.attrs({className: 'policy-table'})`
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;

  @media (min-width: 769px) {
    min-width: none;
  }
  th {
     background: #e5e5e5;
     padding: 1em;
     
  }
  td {
    padding: 1em;
    border-right:1px solid #e5e5e5;
    border-bottom:1px solid #e5e5e5;

    &:last-child {
      border-right:none;
    }
  }
`;


const PolicyProcedure = styled.div.attrs({className: 'policy-procedure'})`
  padding-left: 1.5em;
  .policy-procedure-list {
  padding-left:1em;
  }
  .policy-procedure-list.-low{
    counter-reset: item 1;
    list-style-type: none;
    li {
          text-indent: -1em;
      &:before{
        content: counter(item)". ";
        counter-increment: item;
      }
    }
  }
`;

const PolicyPmark = styled.div.attrs({className: 'policy-pmark'})`
 background: #fff;
 display:flex;
 flex-direction: column;
 padding: 12% 9%;
 margin-top:20%;

 @media (min-width: 769px) {
    padding: 80px;
    flex-direction: row;
    justify-content:space-between;
    align-items: center;
    margin-top:6.25%;
 }

 h3 {
 margin-top:0;
  @media (min-width: 769px) {
  }
 }

`;

const PolicyPmarkInner = styled.div.attrs({className: 'policy-pmark-inner'})`
  @media (min-width: 769px) {
    width: 40%;
    &:nth-child(2){
      width:52.5%;
    }
  }
`;

const PolicyPmarkImg = styled.div.attrs({className: 'policy-pmark-inner'})`
  display:flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  @media (min-width: 769px) {
    flex-direction: row;
    text-align: left;
    align-items: center;
  }
  img {
  width: 40%;
  margin: 0 auto;
    @media (min-width: 769px) {
      width:24%;
      margin-left:0;
    }
  }
    p {
      @media (min-width: 769px) {
        width:70%;
      }
    }
`;

const PolicyPage: React.FC = () => {
  return (
    <PolicyContainer>
      {/* Breadcrumb Navigation */}
      <Breadcrumb 
        items={[
          { label: PAGETITLE_JP } // 現在のページ
        ]} 
      />

      {/* Page Title Section */}
      <PageTitle title={ PAGETITLE_JP } subtitle={ PAGETITLE_EN } />

      {/* Policy Content Section */}
      <PolicyContentSection>
        <p>当社は、当社が取り扱う全ての個人情報の保護について、社会的使命を十分に認識し、本人の権利の保護、個人情報に関する法規制等を遵守します。また、以下に示す方針を具現化するための個人情報保護マネジメントシステムを構築し、最新のIT技術の動向、社会的要請の変化、経営環境の変動等を常に認識しながら、その継続的改善に、全社を挙げて取り組むことをここに宣言します。</p>
        <p>個人情報は、株式会社リブゲート（以下、当社）の、SI事業、Web企画開発事業、ECサイト運営を初めとする様々な業務における当社の正当な事業遂行上並びに従業員の雇用、人事管理上必要な範囲に限定して、取得・利用及び提供をし、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わないための措置を講じます。<br />個人情報保護に関する法令、国が定める指針及びその他の規範を遵守致します。<br />個人情報の漏えい、滅失、き損などのリスクに対しては、合理的な安全対策を講じて防止すべく事業の実情に合致した経営資源を注入し個人情報セキュリティ体制を継続的に向上させます。<br />また、万一の際には速やかに是正措置を講じます。<br />個人情報取扱いに関する苦情及び相談に対しては、迅速かつ誠実に、適切な対応をさせていただきます。<br />個人情報保護マネジメントシステムは、当社を取り巻く環境の変化を踏まえ、適時・適切に見直してその改善を継続的に推進します。</p>
        <p>本方針は、全ての従業者に配付して周知させるとともに、当社のホームページ、パンフレットなどに掲載することにより、いつでもどなたにも入手可能な措置を取るものとします。</p>

        <PolicySignature>
            <p>制定 2011年8月31日<br/>改定 2023年9月22日<br />株式会社リブゲート<br />代表取締役 佐藤 和良</p>
        </PolicySignature>

        <PolicyParagraphHeading>お問い合わせ窓口</PolicyParagraphHeading>
        <p>個人情報保護方針に関するお問い合わせにつきましては、下記窓口で受付けております。</p>
        <p>〒104-0032<br />東京都中央区八丁堀4-13-1　八丁堀東洋ビル3階<br />株式会社リブゲート 個人情報お問い合わせ窓口</p>
        <p>メールアドレス : kikaku_info@lib-gate.co.jp<br />電話：03-6777-9640（受付時間 9:00～18:00）<br />※土・日曜日、祝日、年末年始は翌営業日以降の対応とさせていただきます。</p>

        <PolicyParagraphHeading>個人情報の取扱いについて</PolicyParagraphHeading>
        <PolicyParagraphSubHeading>当社が取り扱う個人情報の利用目的</PolicyParagraphSubHeading>
        <ol>
          <li>ご本人から直接書面によって取得する個人情報（ホームページや電子メール等によるものを含む）の利用目的取得に先立ち、ご本人に対し書面により明示します。</li>
          <li>前項以外の方法によって取得する個人情報の利用目的</li>
        </ol>
        <PolicyTableWrapper>
            <PolicyTable>
              <thead>
                <tr>
                  <th>分類</th>
                  <th>利用目的</th>
                </tr>
              </thead>
              
              <tbody>
                <tr>
                  <td>ECサイトのお客様情報（ユーザー様等）</td>
                  <td>ご利用履歴管理のため お問い合わせ対応のため 注文対応のため</td>
                </tr>
                <tr>
                  <td>お客様情報（お取引先等）</td>
                  <td>発注内容確認のため（通信記録等）</td>
                </tr>
                <tr>
                  <td>業務の受託に伴い、お客様からお預かりする個人情報</td>
                  <td>委託された当該業務を適切に遂行するため</td>
                </tr>
                <tr>
                  <td>協力会社の技術者情報</td>
                  <td>	スキル確認のため 業務遂行のため 契約支払いのため</td>
                </tr>
              </tbody>
            </PolicyTable>
          </PolicyTableWrapper>

        <PolicyParagraphSubHeading>お客様情報の第三者への委託</PolicyParagraphSubHeading>
        <p>当社は、利用目的の達成に必要な範囲内において、お客様情報の全部又は一部を委託する場合があります。</p>

        <PolicyParagraphSubHeading>お客様情報の第三者への提供</PolicyParagraphSubHeading>
        <p>当社は、事前にお客様の同意を得ることなしでお客様情報を第三者（外国にある第三者を含む）に提供しません。<br />
ただし、次に示すいずれかに該当する場合は、この限りではありません。<br />
①あらかじめお客様から同意を得た場合<br />
②当社が利用目的の達成に必要な範囲において個人情報の取扱いの全部または一部を委託する場合<br />
③合併その他の事由による事業の承継に伴って個人データが提供される場合<br />
④国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合<br />
⑤その他、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他の法令で認められる場合</p>
        <p>なお、今後個人情報の利用目的を達成するために外国にある第三者に個人情報を提供する場合は、法令の要求に従って第三者が所在する国名、提供する個人情報や提供目的、講じている個人情報保護措置などを提示し、ご本人からあらかじめ同意を得た上で提供を行います。</p>


        <PolicyParagraphHeading>開示対象個人情報に関する事項の周知</PolicyParagraphHeading>
        <p>当社で保有している開示対象個人情報に関して、ご本人様又はその代理人様からの利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止の請求（以下、「開示等の請求」といいます）につきましては、以下の要領にて対応させていただきます。</p>

        <PolicyParagraphSubHeading>1. 事業者の名称</PolicyParagraphSubHeading>
        <p>事業者名： 株式会社リブゲート<br />
          住所： 東京都中央区八丁堀4-13-1　八丁堀東洋ビル3階<br />
          代表： 佐藤 和良</p>

          <PolicyParagraphSubHeading>2. 全ての開示対象個人情報の利用目的</PolicyParagraphSubHeading>
          <PolicyTableWrapper>
            <PolicyTable>
              <thead>
                <tr>
                  <th>分類</th>
                  <th>利用目的</th>
                </tr>
              </thead>
              
              <tbody>
                <tr>
                  <td>お客様情報（ユーザー様等）</td>
                  <td>ユーザー様サポートのため ご利用履歴管理のため 当社サービスのご案内のため お問い合わせ対応のため</td>
                </tr>
                <tr>
                  <td>お客様情報（お取引先等）</td>
                  <td>発注内容確認のため（通信記録等）</td>
                </tr>
                <tr>
                  <td>当社従業員情報</td>
                  <td>社員の人事労務管理、業務管理、健康管理、セキュリティ管理のため</td>
                </tr>
                <tr>
                  <td>当社への採用応募者情報</td>
                  <td>採用応募者への連絡と当社の採用業務管理のため</td>
                </tr>
              </tbody>
            </PolicyTable>
          </PolicyTableWrapper>

          <PolicyParagraphSubHeading>3. 個人情報の管理責任者</PolicyParagraphSubHeading>
          <p>管理者名職名 : 個人情報保護管理者<br />
            所属部署 : 株式会社リブゲート 管理本部<br />
            連絡先 : 電話03-6777-9640</p>


            <PolicyParagraphSubHeading>4. 開示対象個人情報の取扱いに関する苦情の申し出先</PolicyParagraphSubHeading>
            <p>〒104-0032<br />東京都中央区八丁堀4-13-1　八丁堀東洋ビル3階<br />
            株式会社リブゲート 個人情報お問い合わせ窓口<br />
            メールアドレス : kikaku_info@lib-gate.co.jp<br />
            電話：03-6777-9640</p>


          <PolicyParagraphSubHeading>5. 認定個人情報保護団体</PolicyParagraphSubHeading>
          <PolicyParagraphSubsubHeading>認定個人情報保護団体の名称</PolicyParagraphSubsubHeading>
          <p>一般財団法人日本情報経済社会推進協会</p>
          <PolicyParagraphSubsubHeading>苦情解決の申出先</PolicyParagraphSubsubHeading>
          <p>〒106-0032<br />東京都港区六本木一丁目9番9号 六本木ファーストビル内<br />
          個人情報保護苦情相談室<br />
          電話 : 03-5860-7565<br />
          フリーダイヤル：0120-700-779</p>


          <PolicyParagraphSubHeading>6. 開示対象個人情報の開示等の求めに応じる手続き</PolicyParagraphSubHeading>
          <PolicyParagraphSubsubHeading>1.  開示等の求めの申し出先</PolicyParagraphSubsubHeading>
          <p>開示等のお求めは、上記個人情報お問い合わせ係にお申し出ください。</p>


          <PolicyParagraphSubsubHeading>2. 開示等の求めに関するお手続き</PolicyParagraphSubsubHeading>
          <PolicyProcedure>
            <ol className="policy-procedure-list">
              <li>お申し出受付け後、当社からご利用いただく所定の請求書様式を郵送いたします。なお、お客様が当社保有の個人情報データについてご自身の情報の開示をご希望される場合で、電磁的記録による提供をご希望された場合には、当社は、そのご希望に従って、合理的な期間及び範囲で回答致します。</li>
            </ol>

            <p>【利用目的の通知の場合】<br />
            開示対象個人情報利用目的通知請求書<br />
            【開示の場合】<br />
            開示対象個人情報開示請求書<br />
            【訂正、追加又は削除の場合、利用の停止、消去及び第三者への提供の停止の場合】<br />
            開示対象個人情報訂正等及び利用停止等請求書</p>


            <ol className="policy-procedure-list -low">
              <li>ご記入いただいた請求書、代理人によるお求めの場合は代理人であることを確認する書類、手数料分の郵便為替（利用目的の通知並びに開示の請求の場合のみ）を上記個人情報お問い合わせ係までご郵送ください。</li>
              <li>上記請求書を受領後、ご本人確認のため、当社に登録していただいている個人情報のうちご本人確認可能な2項目程度（例 : 電話番号と生年月日等）の情報をお問い合わせさせていただきます。</li>
              <li>回答は原則としてご本人に対して書面（封書郵送）にておこないます。</li>
            </ol>
          
          </PolicyProcedure>

          <PolicyParagraphSubsubHeading>3. 代理人によるお求めの場合、代理人であることを確認する資料</PolicyParagraphSubsubHeading>
          <p>開示等をお求めになる方が代理人様である場合は、代理人である事を証明する資料及び代理人様ご自身を証明する資料を同封してください。各資料に含まれる本籍地情報は都道府県までとし、それ以降の情報は黒塗り等の処理をしてください。</p>

          <PolicyProcedure>
            <p>1.  代理人である事を証明する資料</p>
            <p>【開示等の求めをすることにつき本人が委任した代理人様の場合】</p>
            <p>本人の委任状（原本）</p>
            <p>【代理人様が未成年者の法定代理人の場合（いずれかの写し）】</p>
            <ul>
              <li>戸籍謄本</li>
              <li>住民票（続柄の記載されたもの）</li>
              <li>その他法定代理権の確認ができる公的書類</li>
            </ul>
            <p>【代理人様が成年被後見人の法定代理人の場合（いずれかの写し）】</p>
            <ul>
              <li>後見登記等に関する登記事項証明書</li>
              <li>その他法定代理権の確認ができる公的書類</li>
            </ul>
            <p>2. 代理人様ご自身を証明する資料</p>
            <ul>
              <li>運転免許証</li>
              <li>パスポート</li>
              <li>健康保険の被保険者証</li>
              <li>住民票</li>
              <li>住民基本台帳カード</li>
            </ul>

          </PolicyProcedure>

          <PolicyParagraphSubsubHeading>4. 利用目的の通知または開示のお求めについての手数料</PolicyParagraphSubsubHeading>
          <p>1回のお求めにつき1000円<br />（お送りいただく請求書等に郵便為替を同封していただきます。）</p>


          <PolicyParagraphSubHeading>7. 保有個人データの安全管理のために講じた措置</PolicyParagraphSubHeading>
          <p>当社における個人データ等の安全管理措置に関する主な内容は以下のとおりです。</p>
          <p>個人情報保護の基本方針の策定</p>
          <ul>
            <li>個人データの適正な確保のため、関係法令を遵守し、個人情報を適正に取り扱うことについて基本方針を策定しています。</li>
          </ul>
          <p>個人データの取り扱いに係わる規律の整備</p>
          <ul>
            <li>取得、利用、保存、提供、削除、廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人データの取扱規定を策定しています。</li>
          </ul>
          <p>組織的安全管理措置</p>
          <ul>
            <li>個人データの取扱に関する責任者を設置するとともに、個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化し、法令や取扱規定に違反している事実または兆候を把握した場合の責任者への報告連絡体制を整備しています。</li>
          </ul>
          <p>人的安全管理措置</p>
          <ul>
            <li>個人データの取扱に関する留意事項について、従業者に定期的な研修を実施しています。</li>
            <li>個人データの秘密保持に関する契約を従業者と締結しています。</li>
          </ul>
          <p>物理的安全管理措置</p>
          <ul>
            <li>個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人データの閲覧を防止する措置を実施しています。</li>
            <li>個人データを取り扱う機器、電子媒体及び書類等の盗難または紛失を防止する措置を実施しています。</li>
          </ul>
          <p>技術的安全管理措置</p>
          <ul>
            <li>アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を決定します。</li>
            <li>個人データを取り扱う情報システムを外部からの不正アクセスまたは不正ソフトウェアから保護する仕組みを導入しています。</li>
          </ul>
          <p>外的環境の把握</p>
          <ul>
            <li>外国において個人データを取り扱う場合は、当該外国における個人情報の保護に関する制度等を把握した上で、安全管理措置を実施します。</li>
          </ul>


          <PolicyParagraphHeading>Cookieポリシー</PolicyParagraphHeading>
          <p>（1）Cookieの利用について<br />本サービスは、お客様のコンピュータの記憶装置に、Cookieと呼ばれるテキストファイルを送付し、保存・利用させていただくことがございます。Cookieを使用する事により具体的には、例えば、興味をお持ちであろう分野のコンテンツを表示する事ができるというメリットがあります。お客様は、Cookieを受け取る前にブラウザが警告を出す様に設定しておく事により、お客様の判断でCookieを受け取る事を拒否できますが、本サービスがご利用になれない場合があります。</p>
        <p>（2）利用目的<br />本サービスは、Google社によるアクセス解析ツールGoogle Analyticsを利用しています。Cookieにより、Google Analyticsの機能が有効となり、当社がウェブサイトの閲覧状況を分析したり、ウェブサイトを改善したりできるようになります。このCookieが個人を識別するための情報を収集することはありません。<br />
        Google Analyticsの利用規約、Google社のプライバシーポリシーに関する説明については同社のサイトをご覧ください。<br />
        Google Analyticsの<a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target='_blank'>利用規約</a>（外部リンク）<br />
        Google<a href="https://policies.google.com/privacy?hl=ja" target='_blank'>プライバシーポリシー</a>（外部リンク）</p>

        <p>（3）Cookieを使用した第三者事業者の広告配信について<br />Googleなどの第三者広告配信事業者は、Cookieを使用して本サービスへのアクセス情報に基づき広告を配信します。第三者広告配信事業者によって取得されたCookie情報等は、第三者広告配信事業者のプライバシーポリシーに従って取り扱われます。<br />
        第三者によって設定されるCookieに関する説明や、Cookieの無効化については、各社のウェブサイト等をご確認ください。</p>


        <PolicyPmark>
          <PolicyPmarkInner>
            <PolicyParagraphSubHeading>『プライバシーマーク』を取得しました</PolicyParagraphSubHeading>
            <PolicyPmarkImg>
              <img src="/assets/images/common/pmark.png" alt="" />
              <p>【認定番号】第21000763号</p>
            </PolicyPmarkImg>
          </PolicyPmarkInner>
          <PolicyPmarkInner>
            <p>株式会社リブゲート（以下、「当社」といいます）は、平成25年5月15日付で、一般財団法人日本情報経済社会推進協会（JIPDEC）から、「プライバシーマーク」付与の認定を受けました。 プライバシーマーク制度は、日本工業規格「JIS Q 15001個人情報保護マネジメントシステム―要求事項」に適合して、個人情報について適切な体制を整備している事業者に付与されるものです。 当社は、お客様からお預かりする個人情報の取り扱いに関し、その重要性を強く認識し、適正な取り扱いと安全管理に努めていきます。</p>
          </PolicyPmarkInner>
        </PolicyPmark>
      </PolicyContentSection>

        
    </PolicyContainer>
  );
};

export default PolicyPage;


